// extracted by mini-css-extract-plugin
export default {"button":"style_button__alkoH","disabled":"style_disabled__On7sy"};